'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by Administrator on 2016/7/28.
                    */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactImageloader = require('react-imageloader');

var _reactImageloader2 = _interopRequireDefault(_reactImageloader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 class LoadingImg extends Component {
 render() {
 return <img src="http://tupian.goeasy.cn:9999/yipinwang/loading.gif" />;
 }
 }*/

function preloader() {
  var img = require('./loading.gif');
  return _react2.default.createElement('img', { src: img });
}

var PreloadImg = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(PreloadImg, _Component);

  function PreloadImg() {
    (0, _classCallCheck3.default)(this, PreloadImg);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(PreloadImg).apply(this, arguments));
  }

  (0, _createClass3.default)(PreloadImg, [{
    key: 'render',
    value: function render() {
      var _props = this.props;
      var img = _props.img;
      var defaultImg = _props.defaultImg;

      var loadingError = require('./loading-error.png');
      return _react2.default.createElement(
        _reactImageloader2.default,
        {
          src: img || defaultImg,
          wrapper: _react2.default.DOM.div,
          preloader: preloader },
        _react2.default.createElement('img', { src: loadingError })
      );
    }
  }]);
  return PreloadImg;
}(_react.Component), _class.propTypes = {
  img: _react.PropTypes.string.isRequired,
  defaultImg: _react.PropTypes.string
}, _temp);
exports.default = PreloadImg;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/GoeasyPreloadImg/GoeasyPreloadImg.js
 ** module id = 150
 ** module chunks = 0
 **/